var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { light: "" } },
    [
      _c(
        "div",
        {
          directives: [{ name: "scroll-y", rawName: "v-scroll-y" }],
          staticClass: "element-buttons"
        },
        _vm._l(_vm.elementos, function(item, i) {
          return _c(
            "v-chip",
            {
              key: i,
              staticClass: "boton-opaco",
              class: { "boton-gris": _vm.botonPresionado === i },
              on: {
                click: function($event) {
                  return _vm.onClick(i)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(item.__nom_flota) + "\n    ")]
          )
        }),
        1
      ),
      _c(
        "v-carousel",
        {
          attrs: { height: "620", cycle: false, "show-arrows": true, dark: "" },
          on: {
            change: function(e) {
              return _vm.onEvent(e)
            }
          },
          model: {
            value: _vm.activeElement,
            callback: function($$v) {
              _vm.activeElement = $$v
            },
            expression: "activeElement"
          }
        },
        _vm._l(_vm.elementos, function(item, i) {
          return _c(
            "v-carousel-item",
            { key: i },
            [
              _c("div", { staticClass: "title" }, [
                _c("h2", { staticStyle: { margin: "0" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.nameTitle) +
                      ": " +
                      _vm._s(item.__nom_flota) +
                      " (" +
                      _vm._s(_vm.cantidadVehiculos) +
                      ")\n          [" +
                      _vm._s(item.avl) +
                      "]\n        "
                  )
                ])
              ]),
              item.cod_flota === _vm.flotaActual
                ? _c("FlotasMap", {
                    attrs: {
                      flota: _vm.flotaActual,
                      loadData: item.cod_flota === _vm.flotaActual,
                      clientData: _vm.clientData
                    }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }